<template>
  <div class="side-list">
    <h3 class="title">回收清单</h3>
    <div class="clearfix">
      <div class="product-logo-wrap fl">
        <img class="product-logo" :src="evInfo.pic">
      </div>
      <div class="fl product-name-wrapper">
        <div>
          <span>商品型号：</span>
          <span class="product-name">{{ evInfo.productName }}</span>
        </div>
      </div>
    </div>
    <div class="price-column clearfix">
      <div class="label fl">预估金额</div>
      <div class="value fr">{{ evInfo.quotation | fen2yuan }}</div>
    </div>
    <div class="price-column clearfix" v-for="active in activeList" :key="active.activityId">
      <span class="label fl">{{ active.activityName }}</span>
      <span class="value fr">{{ active.couponMoney | fen2yuan }}</span>
    </div>
    <div class="price-column clearfix" v-if="selectedCoupon.couponId">
      <div class="label fl">{{ selectedCoupon.couponName }}</div>
      <div class="value fr">{{ selectedCoupon.couponValue | fen2yuan }}</div>
    </div>
    <div class="price-column text-right">
      <span class="text-muted">小计（元）</span>
      <span class="text-danger">{{ totalPrice | fen2yuan }}</span>
    </div>
    <p class="price-tip">*此价格为预估价，最终以检测结果为准*</p>
  </div>
</template>

<script>
export default {
  props: {
    evInfo: Object,
    activeList: Array,
    selectedCoupon: Object,
    totalPrice: [String, Number]
  }
};
</script>

<style lang="postcss" scoped>

.side-list {
  float: left;
  width: 340px;
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
  margin-left: 20px;
  font-size: 14px;
  text-align: left;
  background-color: #fff;
}

.title {
  margin-bottom: 20px;
  font-size: 20px;
  font-weight: 400;
}

.price-column {
  padding-top: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eeeff2;
  &:last-child {
    border-bottom: 0;
  }
}

.product-logo {
  width: 80px;
  height: 80px;
}

.price-tip {
  padding-top: 20px;
  font-size: 14px;
  color: #babcc2;
  text-align: center;
}

.product-name-wrapper {
  margin-top: 29px;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/createOrder/EvaInfo.vue